import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex flex-col items-stretch h-screen relative overflow-auto scrollbar-sm items-center justify-center",
  id: "page"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "guard rise-animation self-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "🛬"),
  /*#__PURE__*/_createElementVNode("div", { class: "" }, "Confirming your purchase")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}